export default __webpack_public_path__ + "static/media/fav-bg.0c6b5d5c.png";